import { getThucDonCuoi, getTruong } from '@/services/Truong/truong';
import { useState } from 'react';
import type { Truong } from '@/services/Truong';

export enum ELoaiHinhDiemDanhGiaoVien {
  WIFI = "WIFI",
  GPS = "GPS"
}

export enum ERefQRCode {
  DEFAULT = "default",
  AUTO = "auto"
}

export default () => {
  const [danhSach, setDanhSach] = useState<Truong.Record[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [total, setTotal] = useState<number>(0);
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [cond, setCondition] = useState<any>({});
  const [typeForm, setTypeForm] = useState<string>();
  const [truongId, setTruongId] = useState<string>();
  const [filterInfo, setFilterInfo] = useState<any>(undefined);
  const [dataThucDonCuoi, setDataThucDonCuoi] = useState<any>();
  const getTruongModel = async (organizationId?: string) => {
    setLoading(true);
    let a = filterInfo;
    const response = await getTruong({ page, limit, cond, organizationId, filterInfo });
    setDanhSach(response?.data?.data?.result ?? []);
    setTotal(response?.data?.data?.total);
    // localStorage.setItem('currentDayQuyetToan')
    setLoading(false);
  };
  const getThucDonCuoiModel = async (id: string, dieuChinh: boolean) => {
    setLoading(true);
    const response = await getThucDonCuoi({ id, dieuChinh });
    setDataThucDonCuoi(response?.data?.data ?? []);
    setLoading(false);
  };

  return {
    danhSach,
    loading,
    setLoading,
    getTruongModel,
    total,
    setTotal,
    page,
    setPage,
    limit,
    setLimit,
    cond,
    setCondition,
    filterInfo,
    setFilterInfo,
    typeForm,
    setTypeForm,
    setTruongId,
    truongId,
    dataThucDonCuoi,
    setDataThucDonCuoi,
    getThucDonCuoiModel
  };
};
